module.exports = __webpack_public_path__ + "media/images/ac_templates/201-neck-print-5ed5ef697f46c3951c16f14c64a20f9d.png";